
import { Vue, Component, Prop } from 'vue-property-decorator'
import * as T from '@/types'
import api from '@/api'

import { UiSidebar, UiSidebarWrapper } from '@hubsolv/hubsolv-ui'
import ViewHeader from '@/components/app/ViewHeader.vue'

export interface SettingsItem {
    name: string
    icon: string
    route: string
    children?: SettingsItem[]
}

@Component({
    components: {
        UiSidebar,
        UiSidebarWrapper,
        ViewHeader,
    },
})
export default class ViewSettings extends Vue {

    ////////////////////////////////////////////////////////////////
    // settings API
    ////////////////////////////////////////////////////////////////

    loading: boolean = false

    allSettings: T.FileTransferSetting[] | null = null

    async created () {
        this.refreshSettings()
    }

    async refreshSettings () {
        try {
            this.allSettings = null
            this.loading = true
            const response = await api.get(`file-transfer-settings`)
            this.allSettings = response.data.data
        } catch (error) {
            console.log( 'error' , error )
        } finally {
            this.loading = false
        }
    }

    ////////////////////////////////////////////////////////////////
    // sidebar
    ////////////////////////////////////////////////////////////////

    get selectedSection () {
        return this.sections.filter((section: SettingsItem) => section.route === this.$route.name)[0]
    }

    get sections () {
        return [
            {
                name: 'Secure FTP',
                icon: 'file-upload',
                route: T.CrmRoute.VIEW_SETTINGS_FTP,
            },
            // {
            //     name: 'Payment profiles',
            //     icon: 'credit-card',
            //     route: T.CrmRoute.VIEW_SETTINGS_PAYMENT,
            // },
        ]
    }

    get sectionedSettings () {
        const sectionedSettings: Record<string, any> = {}
        if (!this.allSettings) return {}
        this.allSettings.forEach((settings) => {
            const key = settings.attributes.transferMethod
            sectionedSettings[key] = settings
        })
        return sectionedSettings
    }

    isItemHighlighted (item: SettingsItem) {
        return item.route === this.selectedSection.route
    }

    getItemIcon (item: SettingsItem) {
        return item.children && item.children.includes(this.selectedSection) ? 'chevron-up' : 'chevron-down'
    }

}
